import React, { FC, useState } from 'react';
import { Button, Checkbox, Col, Divider, Row } from 'antd';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import { StatusColumnItem } from '../../Shared/TableOptions/types';
import CheckboxGroup from 'antd/lib/checkbox/Group';
import styles from './Annotations.module.scss';

type Props = {
  filterProps: FilterDropdownProps;
  filters: StatusColumnItem[];
};

export const StatusFilter: FC<Props> = ({ filterProps, filters }) => {
  const [indeterminatePartially, setIndeterminatePartially] = useState(false);
  const [indeterminateFully, setIndeterminateFully] = useState(false);
  const [allPartiallyChecked, setAllPartiallyChecked] = useState(false);
  const [allFullyChecked, setAllFullyChecked] = useState(false);

  const onChangePartiallyGroup = (e: any) => {
    allPartiallyChecked
      ? filters.forEach((x: StatusColumnItem) => {
          if (x.group === 1) x.checked = false;
        })
      : filters.forEach((x: StatusColumnItem) => {
          if (x.group === 1) x.checked = true;
        });
    setAllPartiallyChecked(e.target.checked);
    if (e.target.checked) setIndeterminatePartially(false);
  };

  const onChangePartiallyStatus = (e: any) => {
    filters.forEach((x: StatusColumnItem) => {
      if (x.value == e.target.value) x.checked = e.target.checked;
    });
    const partiallyGroup = filters.filter((x: StatusColumnItem) => x.group == 1);
    setIndeterminatePartially(
      partiallyGroup.some((x: StatusColumnItem) => !x.checked) &&
        partiallyGroup.some((x: StatusColumnItem) => x.checked)
    );
    setAllPartiallyChecked(partiallyGroup.every((x: StatusColumnItem) => x.checked));
  };

  const onChangeFullyGroup = (e: any) => {
    allFullyChecked
      ? filters.forEach((x: StatusColumnItem) => {
          if (x.group === 2) x.checked = false;
        })
      : filters.forEach((x: StatusColumnItem) => {
          if (x.group === 2) x.checked = true;
        });
    setAllFullyChecked(e.target.checked);
    if (e.target.checked) setIndeterminateFully(false);
  };

  const onChangeFullyStatus = (e: any) => {
    filters.forEach((x: StatusColumnItem) => {
      if (x.value == e.target.value) x.checked = e.target.checked;
    });
    const fullyGroup = filters.filter((x: StatusColumnItem) => x.group == 2);
    setIndeterminateFully(
      fullyGroup.some((x: StatusColumnItem) => !x.checked) && fullyGroup.some((x: StatusColumnItem) => x.checked)
    );
    setAllFullyChecked(fullyGroup.every((x: StatusColumnItem) => x.checked));
  };

  const applyFilter = () => {
    const selectedValues = filters.filter((x) => x.checked).map((x) => x.value);
    filterProps.setSelectedKeys([...(selectedValues as string[])]);
    filterProps.confirm();
  };

  const resetFilter = () => {
    if (filterProps.clearFilters) {
      filterProps.clearFilters();
      filters.forEach((x) => (x.checked = false));
      setIndeterminatePartially(false);
      setIndeterminateFully(false);
      setAllPartiallyChecked(false);
      setAllFullyChecked(false);
    }
  };

  return (
    <div>
      <ul className={styles.statusList}>
        <li>
          <Checkbox
            className={styles.statusGroupItem}
            indeterminate={indeterminatePartially}
            checked={allPartiallyChecked}
            onChange={onChangePartiallyGroup}
          >
            Partially Reviewed Statuses
          </Checkbox>
          <br />
          <CheckboxGroup>
            <ul className={styles.statusList}>
              {filters.map((status: StatusColumnItem) => {
                return status.group === 1 ? (
                  <li key={status.value.toString()}>
                    <Checkbox value={status.value} checked={status.checked} onChange={onChangePartiallyStatus}>
                      {status.text}
                    </Checkbox>
                  </li>
                ) : null;
              })}
            </ul>
          </CheckboxGroup>
        </li>
        <Divider className={styles.filterSeparator} />
        <li>
          <Checkbox
            className={styles.statusGroupItem}
            indeterminate={indeterminateFully}
            checked={allFullyChecked}
            onChange={onChangeFullyGroup}
          >
            Fully Reviewed Statuses
          </Checkbox>
          <br />
          <CheckboxGroup>
            <ul className={styles.statusList}>
              {filters.map((status: StatusColumnItem) => {
                return status.group === 2 ? (
                  <li key={status.value.toString()}>
                    <Checkbox value={status.value} checked={status.checked} onChange={onChangeFullyStatus}>
                      {status.text}
                    </Checkbox>
                  </li>
                ) : null;
              })}
            </ul>
          </CheckboxGroup>
        </li>
      </ul>
      <Divider className={styles.filterSeparator} />
      <Row justify={'space-between'} className={styles.statusFilterActions}>
        <Col span={6}>
          <Button size={'small'} type="link" onClick={resetFilter}>
            Reset
          </Button>
        </Col>
        <Col span={6}>
          <Button size={'small'} type="primary" onClick={applyFilter}>
            OK
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default StatusFilter;
